import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { getActiveToastName, getActiveToastParams } from '../../redux/selectors/activeToast';
import { hideToastAction } from '../../redux/actions/activeToast.actions';
import { sendDashBI } from '../../services/BIService';
import { BIEvents } from '../../consts/bi';
import { toastNameToParams } from './toastNameToParam';
import { getIsSite, getMsid } from '../../redux/selectors/config';
import { Notification } from 'wix-style-react';
import { generateUpgradeLink } from '../../consts/external-links';

export const toastHideTimeout = 3000;

interface IToastProps extends InjectedTranslateProps, ConnectedProps<typeof connector> {}

class Toasts extends React.Component<IToastProps> {

  componentDidUpdate(prevProps: IToastProps) {
    const { activeToastName } = this.props;
    if (activeToastName && activeToastName !== prevProps.activeToastName) {
      this.sendToastShownBI();
    }
  }

  sendToastShownBI = () => {
    const params = toastNameToParams[this.props.activeToastName];
    sendDashBI({
      evid: BIEvents.toastViewed,
      name: params.biName,
      type: params.theme,
      timeout: toastHideTimeout,
    });
  }

  getToastText = (toastDetails, translationParams) => {
    const { t, isSiteLevel } = this.props;
    if (isSiteLevel && toastDetails.siteText) {
      return t(toastDetails.siteText, translationParams);
    } else {
      return t(toastDetails.text, translationParams);
    }
  }

  getActionButton = (toastDetails) => {
    const { actionButtonText } = toastDetails;
    if (actionButtonText) {
      return (<Notification.ActionButton
        type="button"
        onClick={() => window.open(generateUpgradeLink(this.props.msid), '_blank')}
      >
        {this.props.t(actionButtonText)}
      </Notification.ActionButton>);
    } else {
      return null;
    }
  }

  render() {
    const { activeToastName, hideToast, t, activeToastParams } = this.props;
    const { translationParams } = activeToastParams;
    const toastDetails = toastNameToParams[activeToastName];
    if (!toastDetails) {
      return null;
    }
    return (
      <div style={{ height: toastDetails.actionButtonText ? '48px' : '' }} data-hook={toastDetails.dataHook}>
        <Notification
          dataHook="common-toast"
          theme={toastDetails.theme}
          autoHideTimeout={!toastDetails.actionButtonText && toastHideTimeout}
          onClose={hideToast}
          type="local"
          show
          zIndex={1}
        >
          <Notification.TextLabel>
            {this.getToastText(toastDetails, translationParams)}
          </Notification.TextLabel>
          { this.getActionButton(toastDetails) }
          <Notification.CloseButton/>
        </Notification>
      </div>
    );
  }
}

const
  mapStateToProps = state => {
    return {
      activeToastName: getActiveToastName(state),
      activeToastParams: getActiveToastParams(state),
      isSiteLevel: getIsSite(state),
      msid: getMsid(state),
    };
  };

const connector = connect(mapStateToProps, { hideToast: hideToastAction });
export default connector(translate()(Toasts));
